module.exports = __webpack_public_path__ + "static/media/grid_fun.2dcdc699.svg";